// src/pages/Main.styles.js - Main 페이지의 모든 스타일 컴포넌트

import styled, { createGlobalStyle } from 'styled-components';

// 🚀 [접근성] prefers-reduced-motion 전역 스타일
export const ReducedMotionGlobalStyle = createGlobalStyle`
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

// --- 메인 컨테이너 ---
// [수정] MainContainer - height와 padding 충돌 해결
export const MainContainer = styled.div`
  width: 100%;
  /* [수정] height 방식 변경 - padding을 고려한 box-sizing */
  min-height: 100vh;
  min-height: 100dvh;
  /* [수정] Safe area를 고려한 padding - hasWarning 제거됨 */
  padding-top: max(15px, env(safe-area-inset-top));
  padding-bottom: max(60px, env(safe-area-inset-bottom));
  padding-left: ${props => props.$noPadding ? '0' : 'max(1rem, env(safe-area-inset-left))'};
  padding-right: ${props => props.$noPadding ? '0' : 'max(1rem, env(safe-area-inset-right))'};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  position: relative;
  /* [수정] overflow 설정 개선 */
  overflow-y: auto;
  overflow-x: hidden;
  /* 추가: 스크롤 부드럽게 */
  -webkit-overflow-scrolling: touch;
  /* [추가] 스크롤바가 레이아웃에 영향을 주지 않도록 */
  scrollbar-gutter: stable;
`;

// --- 테스트넷 경고 배너 ---
export const TestnetWarningBanner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${props => props.theme.colors.warning};
  color: ${props => props.theme.colors.text};
  /* [수정] padding 절반으로 축소: 10px → 5px */
  padding: 5px 20px;
  text-align: center;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: ${props => props.theme.zIndex.modal};
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  
  .warning-icon {
    /* [수정] 아이콘 크기도 축소 */
    font-size: 16px;
  }
  
  .warning-text {
    /* [수정] 텍스트 크기 축소 */
    font-size: 12px;
  }
`;

// 🆕 [2025-12-19 추가] 테스트 모드 배너 스타일
export const TestModeBanner = styled.div`
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
  color: white;
  padding: 8px 16px;
  text-align: center;
  font-weight: bold;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  
  .test-icon {
    margin-right: 8px;
    font-size: 1.2em;
  }
  
  .test-text {
    font-size: 0.9em;
  }
`;

// --- 사용자 정보 섹션 ---
export const UserInfoSection = styled.div`
  width: 100%;
  max-width: 450px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  backdrop-filter: blur(10px);
  border-radius: ${props => props.theme.borderRadius.xxlarge};
  /* [수정] padding 80% 수준으로 축소: 1rem → 0.8rem */
  padding: 0.8rem;
  /* [수정] margin-bottom 축소: 1rem → 0.6rem */
  margin-bottom: 0.6rem;
  display: flex;
  flex-direction: column;
  /* [수정] gap 축소: 0.6rem → 0.5rem */
  gap: 0.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1;
`;

export const WelcomeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  /* [수정] font-size 축소 */
  font-size: 0.9rem;
  flex-wrap: wrap;
  position: relative;
  justify-content: space-between; /* 좌우 정렬로 공간 최대 활용 */
  
  .nickname {
    font-weight: bold;
    color: ${props => props.theme.colors.gold};
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  }
  
  @media (max-width: 768px) {
    gap: 0.3rem;
    font-size: 0.85rem;
  }
`;

export const EnvBadge = styled.span`
  display: inline-block;
  /* [수정] padding 축소 */
  padding: 3px 6px;
  border-radius: 4px;
  /* [수정] font-size 축소 */
  font-size: 11px;
  font-weight: bold;
  margin-left: 8px;
  
  &.testnet {
    background-color: #ff9800;
    color: ${props => props.theme.colors.text};
  }
  
  &.mainnet {
    background-color: #4caf50;
    color: ${props => props.theme.colors.text};
  }
  
  &.mainnet::after {
    content: 'Mainnet';
  }
`;

export const PremiumBadge = styled.span`
  display: inline-block;
  /* [수정] padding 축소 */
  padding: 3px 6px;
  border-radius: 4px;
  /* [수정] font-size 축소 */
  font-size: 11px;
  font-weight: bold;
  margin-left: 8px;
  background: linear-gradient(135deg, ${props => props.theme.colors.gold} 0%, ${props => props.theme.colors.goldDark} 100%);
  color: ${props => props.theme.colors.textDark};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: shimmer 2s ease-in-out infinite;
  
  @keyframes shimmer {
    0% { opacity: 0.8; }
    50% { opacity: 1; }
    100% { opacity: 0.8; }
  }
`;

// [개선] PP 포인트 표시 스타일 - 테마 플레이 버튼과 유사한 디자인
export const PpPointsDisplay = styled.span`
  font-size: 0.7rem;
  font-weight: 600;
  color: #FFFFFF;
  opacity: 1;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.9);
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.15));
  padding: 2px 12px;
  border-radius: 8px;
  margin-top: 0.1rem;
  margin-left: auto;
  position: relative;
  z-index: 3;
  backdrop-filter: blur(2px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-width: 90px;
  text-align: center;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    font-size: 0.7rem;
    padding: 2px 10px;
    min-width: 100px;
    margin-right: 0.5rem; /* 프리미엄 뱃지와 간격 확보 */
  }
`;

// [추가] 랭킹전 플레이 버튼 스타일
export const RankingPlayButton = styled.button`
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  color: white;
  border: none;
  border-radius: 15px;
  padding: 15px 20px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: linear-gradient(135deg, #666 0%, #444 100%);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
  
  .ticket-info {
    font-size: 14px;
    opacity: 0.9;
  }
  
  .no-tickets {
    font-size: 12px;
    color: #ffcccb;
    font-weight: normal;
  }
  
  @media (max-width: 768px) {
    padding: 12px 16px;
    font-size: 14px;
    
    .ticket-info {
      font-size: 12px;
    }
    
    .no-tickets {
      font-size: 11px;
    }
  }
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.4fr 1fr 0.6fr;
  gap: 6px;
  align-items: center;
  /* [수정] padding-top 축소 */
  padding-top: 0.4rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  
  /* 모바일 최적화 */
  @media (max-width: 768px) {
    gap: 4px;
    padding-top: 0.3rem;
  }
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* [수정] gap 축소 */
  gap: 0.15rem;
  text-align: center;
  
  .label {
    /* [수정] font-size 축소 */
    font-size: 0.65rem;
    color: rgba(255, 255, 255, 0.8);
    
    /* 모바일 최적화 */
    @media (max-width: 768px) {
      font-size: 0.6rem;
    }
  }
  
  .value {
    /* [수정] font-size 축소 */
    font-size: 0.9rem;
    
    /* 모바일 최적화 */
    @media (max-width: 768px) {
      font-size: 0.8rem;
    }
    font-weight: bold;
    color: ${props => props.theme.colors.text};
    
    &.rank-tier {
      color: ${props => props.$tierColor || props.theme.colors.gold};
      text-shadow: 
        0 0 10px ${props => props.$tierColor || props.theme.colors.gold}80,
        1px 1px 3px rgba(0, 0, 0, 0.8),
        -1px -1px 3px rgba(0, 0, 0, 0.8);
      filter: brightness(1.3);
    }
  }
`;

// --- 테마 섹션 ---
export const ThemeSection = styled.div`
  width: 100%;
  max-width: 450px;
  z-index: 1;
  position: relative;
`;

export const SectionTitle = styled.h2`
  /* [수정] font-size 축소 */
  font-size: ${props => props.theme.fontSize.large};
  color: ${props => props.theme.colors.text};
  /* [수정] margin-bottom 축소 */
  margin-bottom: 0.6rem;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  line-height: 1; /* 추가: 텍스트의 line-height를 1로 설정하여 높이 제어 */
  margin: 0; /* 추가: 기본 margin 제거 */
  padding: 0; /* 추가: 기본 padding 제거 */
`;
// 추가할 스타일 컴포넌트
export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between; /* 변경: 아이템들을 양 끝으로 분산 */
  width: 100%;
  margin-bottom: 1.5rem;
  /* position: relative; 제거 */
`;

// SectionTitleRow 다음에 추가
export const RankingButton = styled.button`
  background: rgba(255, 215, 0, 0.1);
  color: #ffd700;
  border: 2px solid #ffd700;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 60px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  /* 🌟 상시 반짝이는 효과를 위한 가상 요소 */
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.4) 50%, transparent 70%);
    transform: rotate(45deg);
    animation: constantShimmer 3s ease-in-out infinite; /* 🎯 상시 반짝거리는 애니메이션 */
  }
  
  /* 모바일 최적화 */
  @media (max-width: 768px) {
    font-size: 8px;
    padding: 4px 6px;
    min-height: 48px;
    gap: 2px;
  }
  
  &:hover {
    background: rgba(255, 215, 0, 0.2);
    border-color: #ffb300;
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
    
    &::before {
      animation: fastShimmer 0.6s ease-in-out; /* 🎯 호버 시 빠른 반짝임 */
    }
  }
  
  &:active {
    transform: translateY(0);
  }
  
  /* 🎯 상시 반짝거리는 애니메이션 (느리고 부드럽게) */
  @keyframes constantShimmer {
    0% {
      transform: rotate(45deg) translateX(-150%);
      opacity: 0;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      transform: rotate(45deg) translateX(150%);
      opacity: 0;
    }
  }
  
  /* 🎯 호버 시 빠른 반짝임 */
  @keyframes fastShimmer {
    0% {
      transform: rotate(45deg) translateX(-100%);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: rotate(45deg) translateX(100%);
      opacity: 0;
    }
  }
`;

// --- 개발자 도구 ---
export const DevToolsContainer = styled.div`
  position: absolute;
  top: 0;
  right: 10px;  /* 수정: -120px → 10px */
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
  
  @media (max-width: 600px) {
    right: 10px;  /* 수정: -110px → 10px */
  }
`;

export const DevButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: ${props => props.theme.colors.text};
  border: none;
  border-radius: 5px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  /* [추가] 성능 최적화를 위한 will-change */
  will-change: filter, box-shadow;
  /* [추가] 터치 액션 최적화 */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  
  &:hover {
    /* [수정] transform 제거, filter 사용으로 reflow 방지 */
    filter: brightness(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
  
  /* [추가] 터치 반응 개선 */
  &:active {
    filter: brightness(0.9);
    transform: scale(0.98);
  }
`;

// --- 테마 그리드 ---
export const ThemeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* [수정] gap 축소 */
  gap: 0.6rem;
  width: 100%; /* 🔄 원래대로 롤백 */
  /* [수정] margin-bottom 축소 */
  margin-bottom: 0.8rem;
  /* [성능 최적화] 뷰포트 밖 렌더링 생략 */
  content-visibility: auto;
  contain-intrinsic-size: 0 200px; /* 카드 높이 예상값 */
`;

export const ThemeCard = styled.div`
  aspect-ratio: 1;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  cursor: ${props => props.$isLocked || props.$isComingSoon || props.$isDownloading ? 'not-allowed' : 'pointer'};
  /* 🚀 [성능 최적화] 첫 페인트 후에만 애니메이션 적용 */
  transition: ${props => props.$afterFirstPaint ? 'all 0.3s ease' : 'none'};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  /* [추가] 성능 최적화를 위한 will-change */
  will-change: ${props => props.$afterFirstPaint ? 'transform, box-shadow' : 'auto'};
  /* [LCP 최적화] 렌더링 최적화 - 카드 단위로만 적용 */
  contain: layout style paint;
  
  /* 🚀 [접근성] prefers-reduced-motion 지원 */
  @media (prefers-reduced-motion: reduce) {
    transition: none !important;
    animation: none !important;
    will-change: auto !important;
  }
  /* [추가] 터치 액션 최적화 */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  /* [추가] 다운로드된 테마 미묘한 효과 */
  ${props => props.$isDownloaded && `
    animation: themeGlow 6s ease-in-out infinite;
  `}
  
  /* [추가] 선택된 테마 강조 효과 */
  ${props => props.$isSelected && `
    border: 3px solid #ffd700;
    box-shadow: 0 0 20px rgba(255, 215, 0, 0.6), 0 4px 15px rgba(0, 0, 0, 0.3);
    animation: selectedGlow 2s ease-in-out infinite;
  `}
  
  &:hover {
    transform: ${props => props.$isLocked || props.$isComingSoon || props.$isDownloading ? 'scale(1.02)' : 'translateY(-5px) scale(1.05)'};
    box-shadow: ${props => props.$isLocked || props.$isComingSoon || props.$isDownloading ? '0 6px 20px rgba(0, 0, 0, 0.35)' : '0 8px 25px rgba(0, 0, 0, 0.4)'};
    /* [LCP 최적화] 호버 애니메이션에만 GPU 가속 적용 */
    transform: ${props => props.$isLocked || props.$isComingSoon || props.$isDownloading ? 'scale(1.02) translateZ(0)' : 'translateY(-5px) scale(1.05) translateZ(0)'};
  }
  
  /* [추가] 터치 반응 개선 */
  &:active {
    transform: scale(0.98);
  }
  
  background-image: ${props => `url(${props.$bgImage})`};
  background-size: cover;
  background-position: center;
  
  ${props => props.$isComingSoon && `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1;
    }
  `}
  
  @keyframes selectedGlow {
    0%, 100% {
      box-shadow: 0 0 20px rgba(255, 215, 0, 0.6), 0 4px 15px rgba(0, 0, 0, 0.3);
    }
    50% {
      box-shadow: 0 0 30px rgba(255, 215, 0, 0.8), 0 4px 15px rgba(0, 0, 0, 0.3);
    }
  }
`;

// 선택 표시 아이콘
export const SelectionIndicator = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  background: #ffd700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: selectionPulse 1.5s ease-in-out infinite;
  
  span {
    color: #000;
    font-weight: bold;
    font-size: 14px;
  }
  
  @keyframes selectionPulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
  }
`;

export const ThemeOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${props => props.$isLocked
    ? 'linear-gradient(to top, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.05) 60%, transparent 100%)'
    : 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0.1) 100%)'};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* [수정] padding 축소 */
  padding: 0.6rem;
  box-sizing: border-box;
  z-index: 2;
`;

export const ThemeTitle = styled.h3`
  /* [수정] font-size 축소 */
  font-size: 0.85rem;
  margin: 0;
  color: ${props => props.theme.colors.text};
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
  text-align: center;
  font-weight: bold;
`;

export const ThemeStatus = styled.div`
  /* [수정] font-size 축소 */
  font-size: 0.65rem;
  color: ${props => props.theme.colors.gold};
  margin-top: 0.2rem;
  text-align: center;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
`;

export const LockIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* [수정] font-size 축소 */
  font-size: 1.8rem;
  z-index: 3;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
  opacity: 0.9;
`;

export const PriceTag = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 215, 0, 0.9);
  color: ${props => props.theme.colors.textDark};
  /* 🔧 padding 추가 축소 (80% 수준) */
  padding: 0.2rem 0.4rem;
  border-radius: 12px;
  /* 🔧 font-size 추가 축소 (80% 수준) */
  font-size: 0.6rem;
  font-weight: 600; /* bold에서 semi-bold로 */
  z-index: 4;
  display: flex;
  align-items: center;
  gap: 0.15rem;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
  transform: scale(0.8); /* 🎯 전체 크기 80%로 축소 */
  transform-origin: top right; /* 우상단 기준으로 축소 */
`;

// --- 다운로드 관련 ---
export const DownloadProgress = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  /* [수정] height 축소 */
  height: 35px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
`;

export const ProgressBar = styled.div`
  width: 80%;
  /* [수정] height 축소 */
  height: 5px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  
  .fill {
    height: 100%;
    background: ${props => props.theme.colors.gold};
    width: ${props => props.$progress}%;
    transition: width 0.3s ease;
  }
`;

export const ProgressText = styled.div`
  position: absolute;
  color: ${props => props.theme.colors.text};
  /* [수정] font-size 축소 */
  font-size: 0.75rem;
  font-weight: bold;
`;

export const DownloadButton = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  /* [수정] height 축소 */
  height: 35px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  color: ${props => props.theme.colors.text};
  /* [수정] font-size 축소 */
  font-size: 0.75rem;
  font-weight: bold;
`;

// --- 게임 모드 섹션 ---
export const GameModeSection = styled.div`
  width: 100%;
  max-width: 450px;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: row; // Changed from column to row
  gap: 0.8rem; // 버튼 간 적절한 간격 설정
  align-items: stretch; // Equal height buttons
`;

// --- 게임 모드 제목 ---
export const GameModeTitle = styled.h3`
  color: ${props => props.theme.colors.text};
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 0.8rem;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 0.6rem;
  }
`;

// --- 이벤트 모드 전용 컨테이너 (독립성 확보) ---
export const EventModeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  
  /* 다른 섹션과의 독립성 확보 */
  isolation: isolate;
`;

// --- 게임 모드 제목 행 (제목 + 상점 버튼 + 시간 표시) ---
export const GameModeTitleRow = styled.div`
  position: relative; /* NFT 버튼의 절대 위치 기준점 */
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.2rem; /* 50% 축소: 0.4rem → 0.2rem */
  gap: 0.4rem; /* 요소 간 간격 2배 증가: 0.2rem → 0.4rem */
  
  @media (max-width: 768px) {
    margin-bottom: 0.15rem; /* 50% 축소: 0.3rem → 0.15rem */
    gap: 0.3rem; /* 모바일에서도 2배 증가: 0.15rem → 0.3rem */
  }
`;

// --- 게임 모드 제목 (행 내부용) ---
export const GameModeTitleText = styled.h2`
  color: ${props => props.theme.colors.text};
  font-size: ${props => props.theme.fontSize.large};
  font-weight: bold;
  margin: 0;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    font-size: ${props => props.theme.fontSize.large};
  }
`;

// --- 게임 모드 NFT 버튼 ---
export const GameModeNftButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  gap: 0.2rem;
  min-width: 50px;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

// --- 게임 모드 상점 버튼 ---
export const GameModeShopButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px; // 12px에서 축소
  padding: 0.3rem 0.6rem; // 0.4rem 0.8rem에서 축소
  font-size: 0.8rem; // 0.9rem에서 축소
  font-weight: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  gap: 0.2rem; // 0.3rem에서 축소
  min-width: 50px; // 60px에서 축소
  justify-content: center;
  grid-column: 3 / 4;
  justify-self: end;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
    min-width: 50px;
  }
`;

// --- 섹션 구분선 ---
export const SectionDivider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(255, 215, 0, 0.3) 20%, 
    rgba(255, 215, 0, 0.5) 50%, 
    rgba(255, 215, 0, 0.3) 80%, 
    transparent 100%
  );
  margin: 1rem 0;
  
  @media (max-width: 768px) {
    margin: 0.8rem 0;
  }
`;

// --- 전역 애니메이션 스타일 ---
export const GlobalAnimations = createGlobalStyle`
  @keyframes constantShine {
    0%, 100% { 
      box-shadow: 0 4px 20px rgba(255, 215, 0, 0.4);
      transform: scale(1);
    }
    50% { 
      box-shadow: 0 8px 30px rgba(255, 215, 0, 0.8);
      transform: scale(1.02);
    }
  }
  
  @keyframes themeGlow {
    0%, 100% { 
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
      filter: brightness(1.1);
    }
    50% { 
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
      filter: brightness(1.2);
    }
  }
`;

// --- 챌린지 컨테이너 ---
// [추가] 이벤트 모드 시간 표시 - 제목과 같은 줄에 배치 (외곽선 제거, 효과 추가)
export const EventTimeDisplayInline = styled.div`
  font-size: 0.65rem;
  color: #ffffff;
  text-align: center;
  line-height: 1.0;
  font-weight: 500; /* 400 → 500으로 약간 증가 */
  max-width: 200px;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3); /* 미묘한 텍스트 그림자 */
  opacity: 0.9; /* 약간의 투명도로 부드러운 느낌 */
  
  @media (max-width: 768px) {
    font-size: 0.6rem;
    max-width: 180px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.55rem;
    max-width: 160px;
  }
`;

// [기존] 이벤트 모드 시간 표시 - 제목에 최대한 가깝게 배치 (백업용)
export const EventTimeDisplay = styled.div`
  font-size: 0.6rem;
  color: #ffffff;
  background: rgba(255, 165, 0, 0.12);
  padding: 0.05rem 0.2rem;
  border-radius: 3px;
  margin: 0 auto 0.5rem auto; /* 상단 마진 완전 제거, 하단 마진 대폭 증가 */
  text-align: center;
  border: 1px solid rgba(255, 215, 0, 0.25);
  line-height: 1.0;
  font-weight: 500;
  max-width: 160px;
  backdrop-filter: blur(1px);
  box-shadow: 0 1px 4px rgba(255, 165, 0, 0.08);
  
  @media (max-width: 768px) {
    font-size: 0.55rem;
    padding: 0.04rem 0.15rem;
    margin: 0 auto 0.45rem auto; /* 모바일에서도 상단 마진 제거, 하단 증가 */
    max-width: 140px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.5rem;
    padding: 0.03rem 0.12rem;
    margin: 0 auto 0.4rem auto;
    max-width: 120px;
  }
`;

export const ChallengeContainer = styled.div`
  display: flex;
  gap: 0.8rem;
  width: 100%;
  margin-top: 0.5rem;
  align-items: stretch;
  
  @media (max-width: 768px) {
    gap: 0.6rem;
    margin-top: 0.4rem;
  }
`;

// --- 챌린지 버튼 ---
export const ChallengeButton = styled.button`
  flex: ${props => props.$isMain ? '7' : '3'};
  padding: 0.5rem; // 0.7rem에서 축소 (다른 버튼들과 일치)
  background: linear-gradient(135deg, ${props => props.theme.colors.gold} 0%, ${props => props.theme.colors.goldDark} 100%);
  color: ${props => props.theme.colors.textDark};
  border: none;
  border-radius: ${props => props.theme.borderRadius.large}; // xxlarge에서 large로 축소
  font-size: 0.85rem; // 다른 버튼들과 일치
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.1rem; // 0.2rem에서 축소
  position: relative;
  overflow: hidden;
  
  /* 모바일 최적화 - 33개국 언어 고려 */
  @media (max-width: 768px) {
    gap: 0.2rem;
  }
  
  .icon {
    font-size: 1.1rem;
    line-height: 1;
    margin-right: 0.1rem;
    
    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }
  
  .title {
    font-size: 0.85rem; // 0.95rem에서 축소 (다른 버튼들과 일치)
    line-height: 1.2;
    text-align: center;
    word-break: break-word;
    hyphens: auto;
    margin-top: 0.05rem; // 간격 축소
    
    @media (max-width: 768px) {
      font-size: 0.75rem;
    }
    
    @media (max-width: 480px) {
      font-size: 0.7rem;
    }
  }

  .ticket-info {
    font-size: 0.65rem; // 0.7rem에서 축소 (다른 버튼들과 일치)
    color: #ffffff;
    background: rgba(0, 0, 0, 0.6);
    padding: 0.15rem 0.3rem; // 패딩 축소
    border-radius: 6px; // border-radius 축소
    margin-top: 0.05rem; // 간격 축소
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    line-height: 1.1;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: 0.6rem;
      padding: 0.1rem 0.25rem;
    }
  }
  
  
  /* 반짝이는 효과 */
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%);
    transform: rotate(45deg);
    transition: all 0.6s;
    opacity: 0;
  }
  
  &:hover {
    filter: brightness(1.1);
    box-shadow: 0 6px 25px rgba(255, 215, 0, 0.4);
    
    &::before {
      animation: shine 0.6s ease-in-out;
    }
  }
  
  &:active {
    filter: brightness(0.95);
    transform: scale(0.98);
  }
  
  @keyframes shine {
    0% {
      transform: rotate(45deg) translateX(-100%);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: rotate(45deg) translateX(100%);
      opacity: 0;
    }
  }
`;

// --- 기존 랜덤 플레이 버튼 (레거시) ---
// 🎯 테마 플레이 버튼 (랭킹 버튼 높이 참고)
export const ThemePlayButton = styled.button`
  flex: 1; // Equal width with RandomPlayButton
  padding: 8px 12px; // 🔧 랭킹 버튼과 동일한 패딩
  min-height: 60px; // 🔧 랭킹 버튼과 동일한 높이
  background: linear-gradient(135deg, ${props => props.theme.colors.gold} 0%, ${props => props.theme.colors.goldDark} 100%);
  color: ${props => props.theme.colors.textDark};
  border: none;
  border-radius: ${props => props.theme.borderRadius.large};
  font-size: 0.85rem; // 랜덤 플레이 버튼과 동일하게
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 25px rgba(255, 215, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; // 🔧 중앙 정렬 추가
  gap: 4px; // 🔧 랭킹 버튼과 동일한 간격
  position: relative;
  overflow: hidden;
  z-index: 1;
  will-change: filter, box-shadow;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  /* 🎨 강화된 상시 애니메이션 */
  animation: enhancedShine 2.5s ease-in-out infinite;
  
  /* 🔧 모바일 최적화 - 랭킹 버튼과 동일 */
  @media (max-width: 768px) {
    padding: 6px 8px;
    min-height: 50px;
    gap: 2px;
  }
  
  
  /* 🎯 첫 번째 span 컨테이너 스타일 */
  span:first-child {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-weight: bold;
    font-size: 1em;
    position: relative;
    z-index: 3;
  }
  
  /* 🎨 재생 아이콘만 파란색 적용 - 모바일 호환성 강화 */
  .play-icon {
    color: #0099FF !important; /* 파란색 재생 아이콘 */
    -webkit-text-fill-color: #0099FF; /* 웹킷 브라우저 호환성 */
    filter: hue-rotate(0deg) saturate(1.5) brightness(1.2); /* 모바일 색상 강제 적용 */
    animation: playIconPulse 2s ease-in-out infinite; /* 펄스 애니메이션 유지 */
  }
  
  /* 🔤 '테마 플레이' 텍스트는 검정색 유지 */
  .play-text {
    color: #000000; /* 검정색 텍스트 */
  }

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.4) 50%, transparent 70%);
    transform: rotate(45deg);
    transition: all 0.6s;
    opacity: 0;
    /* 🎨 더 부드러운 연속 반짝임 */
    animation: continuousShine 3.5s ease-in-out infinite;
  }
  
  &:hover {
    filter: brightness(1.15); /* 1.1에서 증가 */
    box-shadow: 0 8px 40px rgba(255, 215, 0, 0.7); /* 더 강한 호버 그림자 */
    transform: translateY(-2px); /* 살짝 위로 이동 */
    
    /* 🎯 호버 시 아이콘과 텍스트 강조 */
    .play-icon {
      color: #0099FF !important; /* 파란색 유지 */
      -webkit-text-fill-color: #0099FF; /* 웹킷 브라우저 호환성 */
      filter: hue-rotate(0deg) saturate(1.5) brightness(1.2); /* 모바일 색상 강제 적용 */
      transform: scale(1.1);
    }
    
    .play-text {
      color: #000000; /* 검정색 텍스트 유지 */
      transform: scale(1.05);
    }
    
    /* 🌟 호버 시 그림팩 명칭 더 밝게 */
    .desc {
      background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3));
      box-shadow: 0 0 12px rgba(255, 255, 255, 0.6);
      padding: 2px 12px; /* 🔧 호버 시에도 동일한 크기 유지 */
    }
    
    &::before {
      animation: shine 0.6s ease-in-out;
    }
  }
  
  &:active {
    filter: brightness(0.95);
    transform: scale(0.98);
  }
  
  @keyframes shine {
    0% {
      transform: rotate(45deg) translateX(-100%);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: rotate(45deg) translateX(100%);
      opacity: 0;
    }
  }
  
  /* 🎨 강화된 애니메이션 키프레임들 */
  @keyframes enhancedShine {
    0%, 100% {
      box-shadow: 0 6px 25px rgba(255, 215, 0, 0.5);
      transform: scale(1);
    }
    50% {
      box-shadow: 0 8px 35px rgba(255, 215, 0, 0.7);
      transform: scale(1.02); /* 미세한 크기 변화 */
    }
  }
  
  @keyframes playIconPulse {
    0%, 100% {
      /* 🔧 그림자 효과 제거 */
      transform: scale(1);
    }
    50% {
      /* 🔧 그림자 효과 제거 */
      transform: scale(1.05); /* 플레이 아이콘 펄스 */
    }
  }
  
  @keyframes continuousShine {
    0% {
      transform: rotate(45deg) translateX(-100%);
      opacity: 0;
    }
    50% {
      opacity: 0.7; /* 0.5에서 증가 */
    }
    100% {
      transform: rotate(45deg) translateX(100%);
      opacity: 0;
    }
  }
  
  @keyframes descGlow {
    0%, 100% {
      box-shadow: 0 0 0px rgba(255, 255, 255, 0.2);
    }
    50% {
      box-shadow: 0 0 8px rgba(255, 255, 255, 0.4); /* 미세한 글로우 */
    }
  }
  
  /* 🌟 그림팩 명칭 가독성 대폭 개선 - 박스 크기 조정 */
  .desc {
    font-size: 0.7rem; // 0.65rem에서 증가
    font-weight: 600; /* 세미볼드 */
    color: #FFFFFF; /* 순백색 */
    opacity: 1; /* 투명도 제거 */
    text-shadow: 0 2px 6px rgba(0, 0, 0, 0.9); /* 강한 그림자 */
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)); /* 그라데이션 배경 */
    padding: 2px 12px; /* 🔧 세로 더 축소 (3px→2px), 가로 20% 축소 (15px→12px) */
    border-radius: 8px;
    margin-top: 0.1rem;
    position: relative;
    z-index: 3; /* 최상위 표시 */
    backdrop-filter: blur(2px); /* 배경 블러 효과 */
    border: 1px solid rgba(255, 255, 255, 0.1); /* 미세한 테두리 */
    animation: descGlow 3s ease-in-out infinite; /* 미세한 글로우 애니메이션 */
    min-width: 90px; /* 🔧 최소 가로 크기 보장 */
    text-align: center; /* 중앙 정렬 */
  }
  
  /* 🔒 비활성화 상태 개선 */
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    animation: none; /* 애니메이션 중지 */
    
    .play-icon {
      color: #999999 !important; /* 비활성화 시 회색 아이콘 */
      -webkit-text-fill-color: #999999; /* 웹킷 브라우저 호환성 */
      filter: grayscale(1) brightness(0.6); /* 비활성화 시 회색 필터 */
      animation: none; /* 펄스 중지 */
    }
    
    .play-text {
      color: #666666; /* 비활성화 시 회색 텍스트 */
    }
    
    .desc {
      opacity: 0.6;
      animation: none; /* 글로우 중지 */
    }
    
    &:hover {
      filter: none;
      box-shadow: 0 4px 20px rgba(255, 215, 0, 0.4);
    }
  }
`;

// 🎯 랜덤 플레이 버튼 (랭킹 버튼 높이 참고)
export const RandomPlayButton = styled.button`
  flex: 1; // Equal width with ThemePlayButton
  padding: 8px 12px; // 🔧 랭킹 버튼과 동일한 패딩
  min-height: 60px; // 🔧 랭킹 버튼과 동일한 높이
  background: linear-gradient(135deg, ${props => props.theme.colors.gold} 0%, ${props => props.theme.colors.goldDark} 100%);
  color: ${props => props.theme.colors.textDark};
  border: none;
  border-radius: ${props => props.theme.borderRadius.large};
  font-size: 0.85rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(255, 215, 0, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; // 🔧 중앙 정렬 추가
  gap: 4px; // 🔧 랭킹 버튼과 동일한 간격
  position: relative;
  overflow: hidden;
  z-index: 1;
  will-change: filter, box-shadow;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  
  /* 🔧 모바일 최적화 - 랭킹 버튼과 동일 */
  @media (max-width: 768px) {
    padding: 6px 8px;
    min-height: 50px;
    gap: 2px;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%);
    transform: rotate(45deg);
    transition: all 0.6s;
    opacity: 0;
  }
  
  &:hover {
    /* [수정] transform 제거, filter 사용으로 reflow 방지 */
    filter: brightness(1.1);
    box-shadow: 0 6px 30px rgba(255, 215, 0, 0.5);
    
    &::before {
      animation: shine 0.6s ease-in-out;
    }
  }
  
  /* [추가] 터치 반응 개선 */
  &:active {
    filter: brightness(0.95);
    transform: scale(0.98);
  }
  
  @keyframes shine {
    0% {
      transform: rotate(45deg) translateX(-100%);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: rotate(45deg) translateX(100%);
      opacity: 0;
    }
  }
  
  .desc {
    font-size: 0.65rem; // 원래대로 복원
    font-weight: normal; // 원래대로 복원
    opacity: 0.8; // 원래대로 복원
    margin-top: 0.05rem; // 원래대로 복원
  }
`;

/* [추가] 버튼을 한 줄에 배치하기 위한 컨테이너 */
export const ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
  width: 100%;
  max-width: 450px;
  margin-top: 0.6rem;
  position: relative; /* 추가 */
  /* [수정] z-index를 100으로 증가 - 버튼 클릭 문제 해결 */
  z-index: 100; /* 변경: 10 → 100 */
`;

/* [수정] AdFreeButton - 80% 크기로 축소 */
export const AdFreeButton = styled.button`
  /* [수정] 절반 너비로 변경 */
  flex: 1;
  /* [수정] padding 80%로 축소 */
  padding: 0.48rem 0.64rem;
  background: ${props => props.$isActive
    ? 'linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)'
    : 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)'};
  color: ${props => props.theme.colors.text};
  border: none;
  border-radius: ${props => props.theme.borderRadius.xxlarge};
  /* [수정] font-size 80%로 축소 */
  font-size: 0.72rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 3.2px 16px ${props => props.$isActive
    ? 'rgba(46, 204, 113, 0.4)'
    : 'rgba(231, 76, 60, 0.4)'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.08rem;
  /* [수정] margin-top 제거 - ButtonRow에서 처리 */
  position: relative;
  /* [추가] 성능 최적화를 위한 will-change */
  will-change: filter, box-shadow;
  /* [추가] 터치 액션 최적화 */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  /* [추가] pointer-events 명시적 설정 */
  pointer-events: auto;
  
  &:hover {
    /* [수정] transform 제거, filter 사용으로 reflow 방지 */
    filter: brightness(1.1);
    box-shadow: 0 4.8px 24px ${props => props.$isActive
    ? 'rgba(46, 204, 113, 0.5)'
    : 'rgba(231, 76, 60, 0.5)'};
  }
  
  /* [추가] 터치 반응 개선 */
  &:active {
    filter: brightness(0.95);
    transform: scale(0.98);
  }
  
  .time-left {
    /* [수정] font-size 80%로 축소 */
    font-size: 0.52rem;
    opacity: 0.9;
    color: ${props => props.theme.colors.gold};
  }
  
  .desc {
    /* [수정] font-size 80%로 축소 */
    font-size: 0.56rem;
    opacity: 0.9;
  }
  
  .premium-badge {
    position: absolute;
    top: 50%;
    right: 0.4rem;
    transform: translateY(-50%);
    background: ${props => props.theme.colors.gold};
    color: ${props => props.theme.colors.textDark};
    /* [수정] padding 80%로 축소 */
    padding: 0.12rem 0.32rem;
    border-radius: 8px;
    /* [수정] font-size 80%로 축소 */
    font-size: 0.52rem;
    font-weight: bold;
  }
`;

// [수정] 개발자 후원하기 버튼 - 80% 크기로 축소
export const DonationButton = styled.button`
  /* [수정] 절반 너비로 변경 */
  flex: 1;
  /* [수정] padding 80%로 축소 */
  padding: 0.48rem 0.64rem;
  background: linear-gradient(135deg, #ff6ec4 0%, #7873f5 100%);
  color: ${props => props.theme.colors.text};
  border: none;
  border-radius: ${props => props.theme.borderRadius.xxlarge};
  /* [수정] font-size 80%로 축소 */
  font-size: 0.72rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 3.2px 16px rgba(255, 110, 196, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.24rem;
  /* [수정] margin-top 제거 - ButtonRow에서 처리 */
  position: relative;
  overflow: hidden;
  /* [추가] 성능 최적화를 위한 will-change */
  will-change: filter, box-shadow;
  /* [추가] 터치 액션 최적화 */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  /* [추가] pointer-events 명시적 설정 */
  pointer-events: auto;
  
  &::before {
    content: '';
    position: absolute;
    top: -1.6px;
    left: -1.6px;
    right: -1.6px;
    bottom: -1.6px;
    background: linear-gradient(45deg, #ff6ec4, #7873f5, #ff6ec4);
    border-radius: ${props => props.theme.borderRadius.xxlarge};
    opacity: 0;
    z-index: -1;
    transition: opacity 0.3s ease;
  }
  
  &:hover {
    /* [수정] transform 제거, filter 사용으로 reflow 방지 */
    filter: brightness(1.1);
    box-shadow: 0 4.8px 24px rgba(255, 110, 196, 0.5);
    
    &::before {
      opacity: 1;
      animation: gradient 3s ease infinite;
    }
  }
  
  /* [추가] 터치 반응 개선 */
  &:active {
    filter: brightness(0.95);
    transform: scale(0.98);
  }
  
  @keyframes gradient {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  
  span {
    z-index: 1;
  }
`;

// --- 구독 모달 ---
export const AdFreeModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  animation: fadeIn 0.3s ease-in-out;
  padding: 1rem;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const ModalContent = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: ${props => props.theme.colors.text};
  padding: 1.5rem;
  border-radius: 25px;
  text-align: center;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.5);
  width: 100%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  border: 2px solid rgba(255, 215, 0, 0.3);
  animation: slideUp 0.3s ease-out;
  
  @keyframes slideUp {
    from { 
      opacity: 0;
      transform: translateY(30px);
    }
    to { 
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  h3 {
    color: ${props => props.theme.colors.text};
    font-size: 1.5rem;
    margin: 0 0 1rem 0;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  
  .options {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.2rem;
    align-items: center;
    width: 100%;
  }
  
  .button-group {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 1rem;
  }
  
  .cancel-button {
    padding: 0.7rem 1.5rem;
    border: none;
    border-radius: ${props => props.theme.borderRadius.xxlarge};
    font-size: 0.95rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    background: rgba(255, 255, 255, 0.2);
    color: ${props => props.theme.colors.text};
    border: 1px solid rgba(255, 255, 255, 0.3);
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-2px);
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
`;

export const SubscriptionOption = styled.div`
  width: 100%;
  max-width: 300px;
  /* [수정] min-height 축소 */
  min-height: 65px;
  /* [수정] padding 축소 */
  padding: 0.7rem 0.9rem;
  background: ${props => props.$variant === 'basic'
    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.15) 100%)'
    : props.$variant === 'recommended'
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.25) 100%)'
      : 'linear-gradient(135deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 215, 0, 0.25) 100%)'};
  border: 2px solid ${props => props.$variant === 'premium'
    ? props.theme.colors.gold
    : props.$variant === 'recommended'
      ? 'rgba(255, 255, 255, 0.4)'
      : 'rgba(255, 255, 255, 0.3)'};
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
  /* [추가] 성능 최적화를 위한 will-change */
  will-change: transform, filter, box-shadow;
  /* [추가] 터치 액션 최적화 */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
  }
  
  /* [추가] 터치 시 리플 효과 */
  &:active::after {
    width: 300px;
    height: 300px;
  }
  
  &:hover {
    /* [수정] transform 크기 줄임 - reflow 최소화 */
    transform: translateY(-1px) scale(1.01);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
    background: ${props => props.$variant === 'basic'
    ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.2) 100%)'
    : props.$variant === 'recommended'
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.3) 100%)'
      : 'linear-gradient(135deg, rgba(255, 215, 0, 0.2) 0%, rgba(255, 215, 0, 0.3) 100%)'};
    
    &::before {
      opacity: 1;
    }
  }
  
  /* [추가] 터치 반응 개선 */
  &:active {
    transform: translateY(0) scale(0.99);
  }
  
  ${props => props.$variant === 'recommended' && `
    &::after {
      content: '✨';
      position: absolute;
      top: -5px;
      right: -5px;
      font-size: 16px;
      animation: sparkle 1.5s ease-in-out infinite;
      width: auto;
      height: auto;
      background: none;
      transform: none;
    }
    
    @keyframes sparkle {
      0%, 100% { transform: scale(1) rotate(0deg); opacity: 0.8; }
      50% { transform: scale(1.1) rotate(180deg); opacity: 1; }
    }
  `}
  
  ${props => props.$variant === 'premium' && `
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 215, 0, 0.3), transparent);
      animation: shimmer 3s infinite;
      opacity: 0;
      transition: opacity 0.3s;
    }
    
    @keyframes shimmer {
      0% { left: -100%; }
      100% { left: 100%; }
    }
  `}
`;

export const OptionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* [수정] margin-bottom 축소 */
  margin-bottom: 0.3rem;
`;

export const OptionTitle = styled.div`
  /* [수정] font-size 축소 */
  font-size: clamp(0.95rem, 2.8vw, 1.05rem);
  font-weight: bold;
  color: ${props => props.theme.colors.text};
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  .crown-icon {
    font-size: 1.2em;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
  }
`;

export const OptionPrice = styled.div`
  /* [수정] font-size 축소 */
  font-size: clamp(0.9rem, 2.8vw, 1rem);
  font-weight: bold;
  color: ${props => props.theme.colors.gold};
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 0.2rem;
`;

export const OptionDescription = styled.div`
  /* [수정] font-size 축소 */
  font-size: clamp(0.75rem, 2.3vw, 0.8rem);
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.3;
  text-align: left;
  word-wrap: break-word;
  
  .highlight {
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    color: #ff6b6b;
    font-weight: bold;
    font-size: 1em;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    margin: 0 0.2rem;
  }
`;

export const DiscountBadge = styled.div`
  position: absolute;
  top: -8px;
  right: 12px;
  background: #e74c3c;
  color: ${props => props.theme.colors.text};
  /* [수정] padding 축소 */
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  /* [수정] font-size 축소 */
  font-size: 0.65rem;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(231, 76, 60, 0.4);
  white-space: nowrap;
  transform: rotate(3deg);
`;

// --- 하단 바 ---
export const BottomBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  /* [수정] 높이 확대 (아이콘 공간 확보) 45px -> 65px -> [Compact Fit] 50px */
  height: 50px;
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.95) 0%, rgba(45, 27, 105, 0.95) 100%);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* [수정] safe area를 고려한 padding */
  padding: 0 max(1rem, env(safe-area-inset-left)) 0 max(1rem, env(safe-area-inset-right));
  padding-bottom: env(safe-area-inset-bottom);
  box-shadow: none; /* 마스크 때문에 필터 그림자로 대체 */
  border-top: none; /* 곡선 처리를 위해 상단 보더 제거 */
  z-index: 1000;
  gap: 0.5rem;
  
  /* [수정] 배경 투명화 (자식 요소 클리핑 방지) */
  background: transparent;
  backdrop-filter: none;
  box-shadow: none;
  border-top: none;
  z-index: 1000;
  gap: 0.5rem;
  
  /* [핵심] 배경만 따로 처리하여 마스크 적용 (자식 요소 보호) */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(26, 26, 46, 0.95) 0%, rgba(45, 27, 105, 0.95) 100%);
    backdrop-filter: blur(10px);
    
    /* Curved Cradle Mask (오목한 곡선) - V11: Crisp & Tight Restore */
    /* 헐렁한 70px 대신, 다시 단단하고 선명한 36px 곡선으로 복구 -> 30px로 축소 */
    mask-image: radial-gradient(circle 30px at 50% 0, transparent 97%, black 100%);
    -webkit-mask-image: radial-gradient(circle 30px at 50% 0, transparent 96%, black 100%);
    
    /* 그림자 및 보더 효과 */
    border-top: 1px solid rgba(255, 215, 0, 0.3); /* 보더는 마스크에 의해 잘림 */
    filter: drop-shadow(0 -5px 10px rgba(0, 0, 0, 0.3));
    z-index: -1;
  }
  
  /* [추가] 고급스러운 골드 림 (The Golden Arc) - V11 Match */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px; /* 곡선 높이만큼 */
    /* 곡선 라인을 따라 은은한 골드 선 그리기 (30px radius) */
    background: radial-gradient(circle 30px at 50% 0, transparent 29px, rgba(255, 215, 0, 0.8) 30px, transparent 31px);
    z-index: 1001; /* 버튼보다 위에 오지 않도록 주의, 하지만 시각적으론 위에 */
    pointer-events: none;
    opacity: 0.8;
  }
`;

// 파이 브라우저 스타일 하단 네비게이션 아이템 - UI 개선 적용
export const BottomNavItem = styled.button`
  background: transparent;
  color: #E2E8F0;
  border: none;
  border-radius: 15px;
  padding: 0;
  font-size: 1.25rem;
  font-weight: 900;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 60px; /* 터치 영역 충분히 확보 */
  height: 100%; /* 바 높이 꽉 채움 */
  line-height: 1;
  gap: 4px;
  
  /* [수정] 흑백 필터 및 강제 흰색 제거! (색상 제어를 위해) */
  /* filter: grayscale(100%) brightness(500%); 삭제 */
  /* color: #ffffff !important; 삭제 */
  color: #94A3B8; /* 기본값 (Toned Down) */

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    min-width: 50px;
  }
`;

// 하단 네비게이션 텍스트 라벨 - UI 개선 적용
export const BottomNavLabel = styled.span`
  font-size: 0.6em; /* 0.65em → 0.6em (아이콘 대비 한 사이즈 더 작게) */
  font-weight: 500; /* 600 → 500 (PC에서 굵기 감소) */
  color: #94A3B8;
  text-align: center;
  line-height: 1;
  margin-top: 1px; /* 2px → 1px (아이콘-텍스트 간격 더 줄임) */
  text-transform: uppercase; /* [추가] 대문자 강제 변환 */
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  display: block;
  opacity: 1;
  visibility: visible !important;

  /* PC 전용 미디어 쿼리 추가 - 폰트 짤림 방지 및 굵기 조정 */
  @media (min-width: 1024px) {
    font-size: 0.55em; /* PC에서 더 작게 (폰트 짤림 방지) */
    font-weight: 400; /* PC에서 굵기 더 감소 */
    margin-top: 0.5px; /* PC에서 간격 최소화 */
    /* PC 웹 폰트 짤림 방지를 위한 추가 스타일 */
    overflow: visible !important;
    white-space: nowrap;
    text-overflow: visible;
    max-width: none;
    min-width: auto;
    /* PC 폰트 렌더링 최적화 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  @media (max-width: 768px) {
    font-size: 0.55em; /* 0.6em → 0.55em (모바일에서도 한 사이즈 더 작게) */
    margin-top: 0.5px; /* 모바일에서도 간격 최소화 */
  }

  @media (max-width: 480px) {
    font-size: 0.5em; /* 0.55em → 0.5em (작은 화면에서도 한 사이즈 더 작게) */
    margin-top: 0px; /* 작은 화면에서 간격 제거 */
  }
`;


// 투표 버튼 - CSS로 아이콘 색상 직접 제어
export const VoteButton = styled(BottomNavItem)`
  /* 필터 완전 제거 */
  filter: none !important;
  
  /* 아이콘 색상을 CSS로 직접 제어 */
  color: #ffffff !important;
  
  /* 텍스트 색상 명시적 설정 */
  span {
    color: #ffffff !important;
    font-weight: 500 !important;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
`;

export const LanguageSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px; /* 간격 살짝 추가 */
  min-width: 60px; /* 터치 영역 확대 */
  height: 50px; /* 높이 확대 */
  
  @media (max-width: 768px) {
    min-width: 45px;
    height: 35px; /* 모바일 높이도 원래대로 */
  }
  
  /* [추가] 언어 선택 컨테이너 최적화 */
  @media (max-width: 480px) {
    min-width: 40px;
    height: 32px; /* 초소형 모바일에서 더 컴팩트 */
  }
`;

export const VersionDisplay = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  /* [수정] font-size 축소 */
  font-size: 0.6rem;
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
  text-align: right;
  
  &.dev {
    color: #ff6b6b;
  }
  
  &.test {
    color: #ff9800;
  }
`;

// LAND 버튼 - GAME -> MY 버튼으로 변경됨
export const MyButton = styled(BottomNavItem)`
  /* filter: grayscale(100%) !important; 제거 - 활성 상태 색상 표시를 위해 */
`;

// SPOT 버튼 - 중앙 강조 스타일
// SPOT 버튼 - "The Golden Keystone" (통합형 강조 스타일)
// [New] SPOT 아이콘을 감싸는 원형 래퍼 (애니메이션 및 스타일의 주체)
export const SpotIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  /* [수정] Flex 컨테이너 내에서 찌그러짐 방지 (타원형 문제 해결) */
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* 배경: 리얼 골드 그라데이션 */
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
  border-radius: 50%;
  color: #1a1a1a;
  
  /* 돌출 효과 및 정렬 (마스크와 동심원 유지) */
  /* [수정] Flow Layout 복귀 및 높이 미세 조정 */
  position: relative;
  margin: 0;
  /* 
   * 계산: 바 높이 50px, 패딩 8px, 라벨 11px. 
   * IconWrapper Bottom = ~31px from Top. 
   * IconWrapper Height 48px -> Center is at 31 - 24 = 7px from Top.
   * Goal: Center at 0px. Offset: -7px.
   */
  transform: translateY(-7px);
  z-index: 1002; /* 골드 림(1001)보다 위로 올려서 겹침 문제 해결 */
  pointer-events: auto; /* [수정] 돌출된 영역도 클릭 가능하도록 변경 (기존 none에서 변경) */
  
  /* 그림자 & Glassy Ring Border */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 215, 0, 0.3);
  background-clip: padding-box;
  
  /* [추가] 터치 영역 대폭 확장 (가상 요소 활용) */
  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: -6px;
    right: -6px;
    bottom: -6px;
    border-radius: 50%;
    z-index: 2000; /* 최상위 터치 레이어 */
  }
  
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative; /* 가상 요소 기준점 */
  z-index: 10;

  /* [애니메이션] Orbital Flare (빛이 테두리를 타고 흐르는 효과) */
  &::after {
    content: '';
    position: absolute;
    inset: -2px; /* 테두리 포함 전체 감싸기 */
    border-radius: 50%;
    padding: 2px;
    
    /* Comet Tail Gradient */
    background: conic-gradient(
      from 0deg, 
      transparent 75%, 
      rgba(255, 215, 0, 0.6) 90%, 
      #ffffff 95%, 
      transparent 100%
    );
    
    /* Center Cutout */
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    
    animation: spin 4s linear infinite;
    pointer-events: none;
  }
`;

// SPOT 버튼 - "The Golden Arc" (V7: 골든 아크 & 정렬)
export const SpotButton = styled(BottomNavItem)`
  ${props => props.$isMain && `
    /* 분리형 스타일: 아이콘은 뜨고, 텍스트는 바닥에 */
    width: 80px; /* 클릭 영역 확보 및 텍스트 줄바꿈 방지 */
    height: 100%; /* 높이 꽉 채움 */
    margin-top: 0;
    overflow: visible; /* 돌출 허용 */
    
    /* 내용물 정렬 */
    display: flex;
    flex-direction: column;
    align-items: center;
    /* 다른 메뉴들과 텍스트 라인을 맞추기 위해 바닥 패딩 조정 */
    justify-content: flex-end; 
    padding-bottom: 4px; /* 8px -> 4px (텍스트가 너무 떠 보이는 현상 수정) */
    
    /* 아이콘 스타일 초기화 (Wrapper에서 담당) */
    & > svg {
       /* SVG 자체 스타일은 없앰 (Wrapper가 처리) */
    }

    /* [수정] 버튼 자체의 호버 이동 방지 */
    &:hover {
      transform: none;
      background: transparent;
    }
    
    /* 라벨 스타일 */
    ${BottomNavLabel} {
      display: block;
      color: ${props.theme.colors.gold} !important;
      font-weight: 700;
      text-shadow: 0 1px 1px rgba(0,0,0,0.5);
      transform: none;
      margin-top: 0;
      text-transform: uppercase;
      font-size: 0.70rem;
      line-height: 1;
      /* 텍스트와 아이콘 사이 간격 미세 조정 */
      z-index: 20; /* 아이콘보다 및에 깔리지 않도록 */
    }
    
    /* 호버 효과: Wrapper를 타겟팅 */
    /* [중요] 호버 시 베이스 translate(-7px)에 추가 이동(-3px)을 더함 */
    &:hover ${SpotIconWrapper} {
      transform: translateY(-10px) scale(1.05); /* -7px(기본) - 3px(호버) */
      box-shadow: 0 8px 20px rgba(255, 215, 0, 0.5);
      border-color: rgba(255, 215, 0, 0.8);
    }
  `}
`;

// 앱스 버튼 (기존 SwitchButton 재활용 또는 별도 정의)
export const AppsButton = BottomNavItem;

// 메뉴 버튼 - 기본 스타일 사용
export const MenuButton = BottomNavItem;

// 상점 버튼 - 색상 제거 옵션 추가
export const ShopButton = styled(BottomNavItem)`
  ${props => props.$colorless && `
    color: #94A3B8 !important;
    
    & > span, & > svg {
      color: #94A3B8 !important;
      filter: none !important;
    }
  `}
`;

// SPOT 화면 플레이스홀더 스타일
export const SpotViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  gap: 1rem;
  
  .icon {
    font-size: 4rem;
    opacity: 0.5;
    margin-bottom: 1rem;
  }
  
  h2 {
    font-size: 1.5rem;
    color: white;
    margin-bottom: 0.5rem;
  }
  
  p {
    font-size: 1rem;
    max-width: 80%;
    line-height: 1.5;
  }
`;

// --- NFT 버튼 ---
export const NftButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 0.5rem;
  font-size: 1.2rem;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
  }

  &:active {
  transform: translateY(0);
}

  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 0.4rem;
    min-width: 35px;
    height: 35px;
  }
`;

// 공지사항 버튼 스타일
export const NoticeButton = styled.button`
  background: transparent; /* 배경 투명 */
  border: none; /* 테두리 없음 */
  width: 36px; /* 1단계 크게 */
  height: 36px; /* 1단계 크게 */
  font-size: 18px; /* 1단계 크게 */
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff !important; /* 흰색 강제 적용 */
  /* filter: brightness(0) invert(1); 제거 - 본래 이모지 색상 유지 */
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.7); /* 은은한 빛 효과 */
  position: relative; /* 배지 위치 기준 */

  /* 알림 배지 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 8px;
    height: 8px;
    background-color: #ff4d4f; /* 빨간색 */
    border-radius: 50%;
    border: 1px solid #ffffff;
    display: ${props => props.hasNewNotice ? 'block' : 'none'};
    animation: ${props => props.hasNewNotice ? 'pulse 2s infinite ease-in-out' : 'none'};
  }
  
  &:hover {
    transform: translateY(-2px) scale(1.1); /* 호버 효과 유지 */
    text-shadow: 0 0 12px rgba(255, 255, 255, 0.9); /* 호버 시 빛 강화 */
  }
  
  &:active {
  transform: translateY(-1px) scale(1.05); /* 클릭 효과 유지 */
}

  @media (max-width: 768px) {
    width: 32px; /* 모바일도 1단계 크게 */
    height: 32px;
    font-size: 16px;
  }

/* 배지 펄스 애니메이션 */
@keyframes pulse {
  0 % {
    transform: scale(1);
    opacity: 1;
  }
  50 % {
    transform: scale(1.2);
    opacity: 0.8;
  }
  100 % {
    transform: scale(1);
    opacity: 1;
  }
}
`;

export const LanguageSelector = styled.select`
background: rgba(255, 255, 255, 0.1);
color: #ffffff; /* 흰색으로 변경 - 가시성 개선 */
border: 1px solid rgba(255, 215, 0, 0.3);
  /* [수정] padding 최소화 - 매우 컴팩트하게 */
  padding: 0.1rem 0.3rem;
  border-radius: 8px; /* 더 작은 둥근 모서리 */
  /* [UI 개선] font-size 증가 - 가독성 향상 */
  font-size: 0.75rem; /* 0.6rem → 0.75rem (25% 증가) */
  font-weight: 500; /* [추가] 폰트 두께 Medium 적용 */
cursor: pointer;
backdrop - filter: blur(10px);
transition: all 0.2s;
  /* [추가] 성능 최적화를 위한 will-change */
  will-change: background-color, border-color;
  /* [추가] 터치 액션 최적화 */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
/* [추가] 최대 너비 제한 */
  /* [추가] 최대 너비 제한 */
  max-width: 65px; /* 61px → 65px (폰트 크기 증가에 맞춰 조정) */
  height: 26px; /* 24px → 26px (폰트 크기 증가에 맞춰 조정) */
  /* [추가] 텍스트 중앙 정렬 */
  text-align: center;
  /* [추가] 드롭다운 화살표 숨김 (커스텀 스타일링) */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* [추가] 커스텀 드롭다운 화살표 */
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 4px center;
  background-size: 12px;
  padding-right: 20px; /* 화살표 공간 확보 */
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 215, 0, 0.5);
  }

  /* [추가] 터치 반응 개선 */
  &:active {
  background: rgba(255, 255, 255, 0.25);
}
  
  option {
    background-color: #2c3e50;
    font-size: 0.8rem; /* [추가] 드롭다운 옵션 폰트 크기 증가 */
    font-weight: 500; /* [추가] 드롭다운 옵션 폰트 두께 적용 */
    padding: 8px 12px; /* [추가] 옵션 패딩으로 터치 영역 확보 */
  }
`;

// --- 로딩 오버레이 ---
export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  
  .loading-text {
    color: ${props => props.theme.colors.text};
    /* [수정] font-size 축소 */
    font-size: ${props => props.theme.fontSize.large};
    margin-top: 1rem;
  }
  
  .spinner {
    border: 3px solid rgba(255, 215, 0, 0.3);
    border-top: 3px solid ${props => props.theme.colors.gold};
    border-radius: 50%;
    /* [수정] 크기 축소 */
    width: 45px;
    height: 45px;
    animation: spin 1s linear infinite;
  }

@keyframes spin {
  0 % { transform: rotate(0deg); }
  100 % { transform: rotate(360deg); }
}
`;
// --- 동기화 에러 화면 스타일 (추가) ---
// 서버 동기화 실패 시 표시되는 전체 화면 에러 컨테이너
export const SyncErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 50vh;
  padding: 2rem;
  text-align: center;
  /* Safe area 고려 */
  padding-left: max(2rem, env(safe-area-inset-left));
  padding-right: max(2rem, env(safe-area-inset-right));
`;

// 에러 아이콘 - 흔들림 애니메이션 포함
export const ErrorIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  animation: shake 0.5s ease-in-out;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));

  /* 좌우로 흔들리는 애니메이션 */
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-10px); }
    75% { transform: translateX(10px); }
  }
`;

// 에러 제목 - 굵은 텍스트와 그림자 효과
export const ErrorTitle = styled.h2`
  color: ${props => props.theme.colors.text};
  font-size: ${props => props.theme.fontSize.xlarge};
  margin-bottom: 1rem;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  /* 반응형 폰트 크기 */
  font-size: clamp(1.2rem, 4vw, 1.5rem);
`;

// 에러 메시지 - 부드러운 텍스트와 줄바꿈 지원
export const ErrorMessage = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: ${props => props.theme.fontSize.normal};
  line-height: 1.6;
  margin-bottom: 2rem;
  max-width: 400px;
  /* 줄바꿈 문자(\n) 처리를 위한 설정 */
  white-space: pre-line;
  /* 반응형 폰트 크기 */
  font-size: clamp(0.85rem, 2.5vw, 1rem);
`;

// 재시도 버튼 - 황금색 그라데이션과 호버 효과
export const RetryButton = styled.button`
  background: linear-gradient(135deg, ${props => props.theme.colors.gold} 0%, ${props => props.theme.colors.goldDark} 100%);
  color: ${props => props.theme.colors.textDark};
  padding: 0.8rem 2rem;
  border: none;
  border-radius: ${props => props.theme.borderRadius.round};
  font-size: ${props => props.theme.fontSize.normal};
  font-weight: bold;
  cursor: pointer;
  transition: all ${props => props.theme.transitions.fast};
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  /* 성능 최적화 */
  will-change: transform, box-shadow, filter;
  /* 터치 액션 최적화 */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  /* 호버 효과 - 위로 살짝 올라가며 빛남 */
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 215, 0, 0.5);
    filter: brightness(1.1);
  }

  /* 클릭 효과 */
  &:active {
    transform: translateY(0);
    filter: brightness(0.95);
  }

  /* 비활성화 상태 */
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    filter: none;
  }
`;

// 모달 오버레이 - 배경 어둡게 처리
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${props => props.theme.zIndex.modal};
  padding: 1rem;
  /* Safe area 고려 */
  padding-top: max(1rem, env(safe-area-inset-top));
  padding-bottom: max(1rem, env(safe-area-inset-bottom));
  padding-left: max(1rem, env(safe-area-inset-left));
  padding-right: max(1rem, env(safe-area-inset-right));
`;

// 모달 헤더 - 제목과 닫기 버튼
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px 8px 0 0;

  h3 {
    margin: 0;
    color: #ffffff;
    font-size: 1.3rem;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  button {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #ffffff;
    cursor: pointer;
    padding: 0.25rem;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
      background-color: ${props => props.theme.colors.hover};
    }
  }
`;

// 모달 본문
export const ModalBody = styled.div`
  padding: 1.5rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 0 0 8px 8px;
  max-height: 70vh;
  overflow-y: auto;
  
  h4 {
    color: #2c3e50;
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0 0 1rem 0;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  
  p {
    color: #34495e;
    font-size: 1rem;
    font-weight: 500;
    margin: 0.5rem 0;
    line-height: 1.4;
  }
  
  button {
    font-weight: 600;
    font-size: 0.95rem;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    &:active {
      transform: translateY(0);
    }
  }
`;

// 모달 컨텐츠 (기존 LegacyModalContent와 통합됨)
export const LegacyModalContent = styled.div`
  background-color: ${props => props.theme.colors.background};
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  max-width: 90vw;
  max-height: 90vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;



// 전환 버튼 - 기본 스타일 사용
export const SwitchButton = BottomNavItem;

// --- 티켓 정보 표시 ---
export const TicketInfo = styled.span`
  font-size: 0.7rem;
  color: #ffd700;
  background: rgba(255, 215, 0, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 8px;
  margin-top: 0.2rem;
  display: block;
  text-align: center;
  border: 1px solid rgba(255, 215, 0, 0.3);

  @media (max-width: 768px) {
    font-size: 0.65rem;
    padding: 0.15rem 0.3rem;
  }
`;

// --- 토스트 메시지 ---
export const StyledToast = styled.div`
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  animation: toastSlideDown 0.3s ease-out, toastFadeOut 0.5s ease-in 2.5s forwards;
  pointer-events: none;
  white-space: nowrap;

  @keyframes toastSlideDown {
    from {
      transform: translate(-50%, -20px);
      opacity: 0;
    }
    to {
      transform: translate(-50%, 0);
      opacity: 1;
    }
  }

  @keyframes toastFadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;